import Vue from 'vue';
import ediOrderTransformer from '../../transformers/ediOrder';

const success = (data, resolve) => {
  const result = {
    errors: data.errors,
    data: ediOrderTransformer.fetchCollection(data.data),
  };
  resolve(result);
};

const failed = (error, reject) => reject(error);

export default (orderIds, order) => (
  new Promise((resolve, reject) => {
    const url = `/edi_orders/confirm-order-shipping?order_ids=${orderIds.join(',')}`;

    Vue.$http
      .post(url, order)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/ediOrder/bulkConfirmAndShipping.js